export default __webpack_public_path__ + "static/media/2Servicios.7ce17cc3.svg";